export const handleDialogAPIErrors = (error: any, showToast: (translationKey: string) => void) => {
  // Handle platform-specific Dialog API errors
  if (error?.code === 13012) {
    showToast('errors.fallback.platformNotSupported');
  } else {
    showToast('errors.fallback.general');
  }
};
